import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";
import { KEYS, endSession, markActivity, saveSession } from "@/lib/session";

const AuthContext = createContext(null);

export const ROLE_LABEL = { super_admin: "Super Admin", admin: "Admin", admin_siport: "Admin SIPORT", kepala_unit: "Kepala Unit" };
// Admin SIPORT = view-only modul SIPORT; hanya boleh membuka halaman ini (backend tetap menolak endpoint lain).
export const SIPORT_VIEWER_PATHS = ["/siport/dashboard", "/siport/data", "/ganti-password"];
export const isSiportViewerRole = (u) => !!u && u.role === "admin_siport";
// Kepala Unit = view-only: 5 halaman Indikator Mutu + 2 halaman SIPORT (tanpa export). Backend tetap menolak selain itu.
export const KEPALA_UNIT_PATHS = [
  "/dashboard", "/rekap-departemen", "/rekap-bulan", "/dashboard-departemen", "/ringkasan",
  "/siport/dashboard", "/siport/data", "/ganti-password",
];
export const isKepalaUnitRole = (u) => !!u && u.role === "kepala_unit";
export const isViewOnlyRole = (u) => isSiportViewerRole(u) || isKepalaUnitRole(u);
export const allowedPaths = (u) => (isKepalaUnitRole(u) ? KEPALA_UNIT_PATHS : isSiportViewerRole(u) ? SIPORT_VIEWER_PATHS : null);
export const homePath = (u) => (isSiportViewerRole(u) ? "/siport/dashboard" : "/dashboard");

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = not auth
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem(KEYS.token);
    if (!token) {
      setUser(false);
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((res) => setUser(res.data))
      .catch(() => setUser(false))
      .finally(() => setLoading(false));
  }, []);

  const login = async (username, password) => {
    const sentAt = Date.now();
    const res = await api.post("/auth/login", { username, password });
    saveSession(res.data, sentAt);
    markActivity();
    setUser(res.data.user);
    return res.data.user;
  };

  // Logout biasa; tab lain ikut keluar lewat storage event (lihat SessionGuard).
  const logout = () => {
    setUser(false);
    endSession("keluar");
  };

  const isSuperAdmin = !!user && user.role === "super_admin";
  const isKepalaUnit = isKepalaUnitRole(user);
  // true untuk Admin SIPORT & Kepala Unit: modul SIPORT hanya dilihat (tanpa edit/verifikasi/hapus/Master/Pengaturan/Import)
  const isSiportViewer = isSiportViewerRole(user) || isKepalaUnit;

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout, loading, isSuperAdmin, isSiportViewer, isKepalaUnit }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
